import React, { useState, useEffect, useMemo } from "react";
import ContentHeader from "../../components/ContentHeader";
import { FiPlusCircle } from "react-icons/fi";
import SearchFilter from "../../components/SearchFilter";
import {
  Button,
  Col,
  Dropdown,
  Menu,
  Pagination,
  Row,
  Select,
  Space,
  Table,
} from "antd";
import { options, options_issenior_0, options_issenior_3 } from "./constants";
import moment from "moment";
import SalesService from "../../services/Sales.services";
import getUserOtp from "../../services/Sales.services";

import TeamService from "../../services/Team.services";
import localStorageContent from "../../utils/localstorage";
import DashboardService from "../../services/Dashboard.services";
import { useLocation, useNavigate } from "react-router-dom";
import formateNum from "format-thousands";
import "./styles.scss";
import { useDispatch } from "react-redux";
import { setError } from "../../store/reducers";
import DownloadCsv from "../../utils/downloadCSV";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import EditUserModal from "./EditModal";
import dayjs from "dayjs";
import DeleteModal from "./DeleteModal";
import Input from "antd/es/input/Input";

const Sales = () => {
  const [totalCount, setTotalCount] = useState<number>(0);
  const [status, setStatus] = useState("");
  const [queryString, setQueryString] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [salesList, setSalesList] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [teamList, setTeamList] = useState<any[]>([]);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [currentEditUser, setCurrentEditUser] = useState<boolean>(false);
  const [filterCount, setFilterCount] = useState<any>({
    interested: 0,
    notInterested: 0,
    notReachable: 0,
  });
  const [selectedLeads, setSelectedLeads] = useState<any[]>([]);
  const [teamAssignigIds, setTeamAssignigIds] = useState<any[]>([]);
  const [otpEmail, setOtpEmail] = useState("");
  const [fetchedOtp, setFetchedOtp] = useState("");
  const [loadingOtp, setLoadingOtp] = useState(false);

  const handleGetOtp = async () => {
    if (!otpEmail) {
      dispatch(
        setError({
          status: true,
          type: "error",
          message: "Please enter email",
        }),
      );
      return;
    }

    try {
      setLoadingOtp(true);

      const response = await SalesService.getUserOtp(otpEmail);

      // Adjust based on API response structure
      setFetchedOtp(response?.otp || response?.data?.otp || "OTP not found");
    } catch (error) {
      dispatch(
        setError({
          status: true,
          type: "error",
          message: "Failed to fetch OTP",
        }),
      );
    } finally {
      setLoadingOtp(false);
    }
  };

  const localUserData = localStorageContent.getUserData();
  const {
    getsalesList,
    generateCronJob,
    generateSubmissionLeadsJob,
    generateWalkoutLeadsJob,
    generateVoicemailsJob,
    assignSalesContactsToTeam,
    deleteSalesData,
  } = SalesService;
  const { getTeamList } = TeamService;
  const { getDashboardDetails } = DashboardService;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [dataLoaded, setDataLoaded] = useState<boolean>(false);
  const [error, setErrorState] = useState<string | null>(null);
  const [refreshPage, setRefreshPage] = useState<boolean>(false);

  const exportFormates: any = {
    created_dt: (value: any) =>
      value ? `${moment(value).format("DD-MM-YYYY")}` : "",
    name: (value: any) => (value ? value : ""),
    status: (value: any) =>
      value ? options.find((opt) => opt.value === value)?.label : "",

    contact_type: (value: number) => statusList[value] || "",
  };

  const toggleEditModal = (data: any) => {
    setShowEditModal(!showEditModal);
    setCurrentEditUser(data);
  };

  const toggleDeleteModal = (data: any) => {
    const shouldOpen = !!data; // open if data provided, otherwise close
    setShowDeleteModal(shouldOpen);
    setCurrentEditUser(data);
  };

  const doMultipleAssign = async (id: any) => {
    const result = window.confirm("Dude, are you sure you want to assign?");
    if (!result) return;
    handleAgents("", id);
  };
  const handleAgents = async (e: any, leadId: any) => {
    try {
      const contactIdsAarray = selectedLeads?.map((id) => Number(id));
      const response = await assignSalesContactsToTeam({
        teamId: leadId,
        contactIds: contactIdsAarray,
      });
      if (response) {
        dispatch(
          setError({
            status: true,
            type: "success",
            message: response?.message,
          }),
        );
      }

      setSelectedLeads([]);
      setRefreshPage(true);
    } catch (err: any) {
      dispatch(setError({ status: true, type: "error", message: err }));
    }
  };
  const filterOption = (
    input: string,
    option?: { label: string; value: string },
  ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  const statusList = [
    "",
    "Paid Data",
    "Unpaid Data",
    "Server Data",
    "Senior Data",
    "Junior Data",
    "All Data",
    "Referral Data",
    "Existing Data",
  ];
  const fieldsData = [
    {
      label: "Team List",
      key: "teamId",
      elementType: "SELECT",
      onChangeField: () => {},
      options: teamList,
      required: true,
      disable: false,
      type: "string",
      placeholder: "Select an team member",
      config: {
        rules: [{ required: false, message: "Please select an team member" }],
      },
    },
    {
      label: "Status",
      key: "status",
      elementType: "SELECT",
      onChangeField: (e: any) => setStatus(e),
      options: options,
      required: true,
      disable: false,
      type: "string",
      placeholder: "Select Status",
      config: {
        rules: [{ required: false, message: "Please Enter Status" }],
      },
    },
    {
      label: "Name",
      key: "name",
      elementType: "INPUT",
      required: true,
      disable: false,
      onChangeField: () => {},
      type: "text",
      placeholder: "Search by Name",
      config: {
        rules: [{ required: false, message: "Please Enter Name" }],
      },
    },
    {
      label: "Upload type",
      key: "contactType",
      elementType: "SELECT",
      onChangeField: (e: any) => {},
      options: [],
      required: true,
      disable: false,
      type: "string",
      placeholder: "Select Status",
      config: {
        rules: [{ required: false, message: "Please Enter Status" }],
      },
    },
  ];

  const columns = [
    {
      title: "F.No",
      dataIndex: "file_id",
      key: "file_id",
    },
    {
      title: "S.No",
      dataIndex: "id",
      key: "id",
      className: "noselect",
    },
    {
      title: "Team Member",
      dataIndex: "team_member",
      key: "team_member",
      className: "noselect",
    },
    {
      title: "Added Date",
      dataIndex: "created_dt",
      className: "noselect",
      key: "created_dt",
      render: (created_dt: string) => {
        return (
          <div>
            <p>{dayjs(created_dt).format("YYYY-MM-DD HH:mm:ss")}</p>
          </div>
        );
      },
    },
    {
      title: "Name",
      key: "name",
      className: "noselect",
      render: (text: any, record: any) => {
        const cleanName = record.name
          ?.replace(/[^\x20-\x7E]/g, " ")
          .replace(/\s+/g, " ")
          .trim();
        return cleanName;
      },
    },
    {
      title: "Email ID",
      dataIndex: "email",
      key: "email",
      className: "noselect",
      render: (email: string) => {
        const cleanEmail = email?.replace(/[^\x20-\x7E]/g, "").trim();
        return cleanEmail;
      },
    },
    {
      title: "Number",
      dataIndex: "phone_number",
      key: "phone_number",
      className: "noselect",
      render: (phone: string) => {
        const cleanPhone = phone?.replace(/[^\d+]/g, "").trim();
        return cleanPhone;
      },
    },
    {
      title: "Upload type",
      dataIndex: "contact_type",
      key: "contact_type",
      render: (record: any) => (
        <div>
          <p>{statusList[record]}</p>
        </div>
      ),
    },
    {
      title: "Action",
      key: "status",
      render: (record: any) => (
        <div>
          <p>
            {record?.status !== null
              ? options.find((opt) => opt.value === record?.status)?.label
              : "--"}
          </p>
        </div>
      ),
    },

    ...(localUserData?.departmentId === 1 && localUserData?.role !== "5"
      ? [
          {
            title: "Edit User",
            render: (record: any) => (
              <Space size="middle">
                <span onClick={() => toggleEditModal(record)}>
                  <EditOutlined style={{ color: "#3AA0E9" }} />
                </span>
              </Space>
            ),
          },
          {
            title: "Delete User",
            render: (record: any) => (
              <Space size="middle">
                <span onClick={() => toggleDeleteModal(record)}>
                  <DeleteOutlined
                    style={{ color: "#c2172eff", cursor: "pointer" }}
                  />
                </span>
              </Space>
            ),
          },
        ]
      : []),
  ];

  const generateSearchFields = useMemo(() => {
    const copyFields = fieldsData;
    let fields: any[] = [];
    if (
      localUserData?.role === "1" ||
      localUserData?.role === "2" ||
      localUserData?.departmentId === 1
    ) {
      fields = copyFields;
    } else {
      copyFields.splice(0, 1);
      fields = copyFields;
    }
    fields.map((item) => {
      if (item.label === "Upload type") {
        item.options = status === "0" ? options_issenior_0 : options_issenior_3;
      }
    });
    return fields;
  }, [teamList, status]);

  const fetchTeamList = async () => {
    try {
      if (localUserData === null || localUserData.role === "3") {
        // Don't fetch if no user or if role is 3
        setTeamList([]);
        setDataLoaded(false);
        return;
      }
      setIsLoading(true); // Start loading
      // const response = await getTeamList(`/team?deptId=${localUserData?.role === '1' ? 1 : localUserData?.departmentId}`);
      const response = await getTeamList(
        `/team/search-teams?deptId=${
          localUserData?.role === "1" ? 1 : localUserData?.departmentId
        }&status=1`,
      );

      // Check if response and response.data are defined
      if (response && response.data) {
        const filterData: any[] = [];
        response.data.forEach((team: any) => {
          // if (team?.departments?.length > 0 && team?.departments?.some((dep: any) => dep.id === (localUserData?.role === '1' ? 1 : localUserData?.departmentId))) {
          filterData.push({
            label: team?.first_name + " " + team?.last_name,
            value: team.user_id,
          });
          // }
        });
        setTeamList(filterData);
        setDataLoaded(true); // Mark data as loaded
      } else {
        // Handle case where response or response.data is undefined
        setTeamList([]);
        setDataLoaded(false); // Mark data as not loaded
      }
    } catch (err: any) {
      setTeamList([]); // Clear teamList on error
      setDataLoaded(false); // Mark data as not loaded
      setErrorState(
        err.message || "An error occurred while fetching team data",
      );
      dispatch(
        setError({
          status: true,
          type: "error",
          message: err.message || "An error occurred",
        }),
      );
    } finally {
      setIsLoading(false); // End loading
    }
  };

  const getSalesDashboardReports = async (query: any) => {
    try {
      setIsLoading(true);
      let URL = query
        ? `/dashboard/sales-reports?${query}`
        : "/dashboard/sales-reports";
      const response = await getDashboardDetails(URL);

      if (response) {
        const dashboard = response?.data || {};
        const {
          pending = 0,
          interested = 0,
          followup = 0,
          notInterested = 0,
          voicemail = 0,
          invalidNumber = 0,
          notInService = 0,
          dnd = 0,
          citizens = 0,
        } = dashboard;
        setFilterCount({
          pending,
          interested,
          followup,
          notInterested,
          voicemail,
          invalidNumber,
          notInService,
          dnd,
          citizens,
        });
        setDataLoaded(true);
      } else {
        setFilterCount({});
        setDataLoaded(false);
      }
    } catch (err: any) {
      setFilterCount({});
      setDataLoaded(false);
      setErrorState(
        err.message ||
          "An error occurred while fetching sales dashboard reports",
      );
      dispatch(
        setError({
          status: true,
          type: "error",
          message: err.message || "An error occurred",
        }),
      );
    } finally {
      setIsLoading(false);
    }
  };

  const getSalesListData = async (page: number, query: string | null) => {
    try {
      setIsLoading(true);
      const response = await getsalesList(
        query
          ? `/sales/contacts?page=${page + "&" + query}`
          : `/sales/contacts?page=${page}`,
      );

      // Check if response and response.data are defined
      if (response && response.data) {
        setSalesList(response.data);
        setTotalCount(response.totalRows || 0); // Use a default value if totalRows is undefined
        setDataLoaded(true); // Mark data as loaded
      } else {
        // Handle case where response or response.data is undefined
        setSalesList([]);
        setTotalCount(0);
        setDataLoaded(false); // Mark data as not loaded
      }
    } catch (err: any) {
      setSalesList([]); // Clear salesList on error
      setTotalCount(0); // Reset total count on error
      setError(err.message || "An error occurred while fetching sales data");
      dispatch(
        setError({
          status: true,
          type: "error",
          message: err.message || "An error occurred",
        }),
      );
    } finally {
      setIsLoading(false);
    }
  };

  const genarateCronData = async () => {
    try {
      dispatch(
        setError({
          status: true,
          type: "success",
          message: "Cron Job Initiated",
        }),
      );
      const response = await generateCronJob();
      if (response) {
        dispatch(
          setError({
            status: true,
            type: "success",
            message: "Cron Job Successfull",
          }),
        );
      }
    } catch (err: any) {
      dispatch(setError({ status: true, type: "error", message: err }));
    }
  };

  // put this before columns
  const submitDeleteUser = async (record: any) => {
    alert(1);
    try {
      const contactId =
        record?.id || record?.lead_id || record?.contact_id || record?._id;

      console.log("DELETE ID:", contactId, record);

      if (!contactId) {
        dispatch(
          setError({
            status: true,
            type: "error",
            message: "Contact ID not found.",
          }),
        );
        return;
      }

      const confirmed = window.confirm(
        `Are you sure you want to delete ${record?.name || "this contact"}?`,
      );
      if (!confirmed) return;

      const payload = {
        deletedBy: localUserData?.user_id || "admin",
      };

      const response = await deleteSalesData(contactId, payload);

      if (response) {
        getSalesListData(currentPage, queryString);
        dispatch(
          setError({
            status: true,
            type: "success",
            message: "Contact deleted successfully",
          }),
        );
      }
    } catch (err: any) {
      dispatch(
        setError({
          status: true,
          type: "error",
          message: err?.response?.data?.message || err.message,
        }),
      );
    }
  };

  const generateSubmissionLeads = async () => {
    try {
      dispatch(
        setError({
          status: true,
          type: "success",
          message: "Cron Job Initiated",
        }),
      );
      const response = await generateSubmissionLeadsJob();
      if (response) {
        dispatch(
          setError({
            status: true,
            type: "success",
            message: "Cron Job Successfull",
          }),
        );
      }
    } catch (err: any) {
      dispatch(setError({ status: true, type: "error", message: err }));
    }
  };
  const generateWalkoutLeads = async () => {
    try {
      dispatch(
        setError({
          status: true,
          type: "success",
          message: "Cron Job Initiated",
        }),
      );
      const response = await generateWalkoutLeadsJob();
      if (response) {
        dispatch(
          setError({
            status: true,
            type: "success",
            message: "Cron Job Successfull",
          }),
        );
      }
    } catch (err: any) {
      dispatch(setError({ status: true, type: "error", message: err }));
    }
  };

  const generateVoicemails = async () => {
    try {
      dispatch(
        setError({
          status: true,
          type: "success",
          message: "Cron Job Initiated",
        }),
      );
      const response = await generateVoicemailsJob();
      if (response) {
        dispatch(
          setError({
            status: true,
            type: "success",
            message: "Cron Job Successfull",
          }),
        );
      }
    } catch (err: any) {
      dispatch(setError({ status: true, type: "error", message: err }));
    }
  };

  useEffect(() => {
    // Only fetch data if it has not been loaded already
    // if (!dataLoaded) {
    getSalesListData(currentPage, queryString);
    // }
  }, [currentPage, queryString, !refreshPage]);

  useEffect(() => {
    if (
      localUserData?.role === "1" ||
      localUserData?.role === "2" ||
      localUserData?.departmentId === 1
    ) {
      if (!dataLoaded) {
        fetchTeamList();
      }
    }
    if (!dataLoaded) {
      getSalesDashboardReports(null); // Fetch sales dashboard reports if data has not been loaded
    }
  }, []);
  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      console.log("Hey selectedrows", selectedRowKeys);
      if (selectedRowKeys.length > 0) {
        const data = selectedRowKeys?.toString().split(",");
        const mappedData = data.map((item) => {
          return { lead_id: item };
        });
        console.log("hellomappedData", mappedData);
        const ids = mappedData?.map((item) => item?.lead_id);

        setSelectedLeads(ids);
      } else {
        setSelectedLeads([]);
      }
    },
    getCheckboxProps: (record: any) => ({
      disabled: record.name == "Disabled User", // Column configuration not to be checked
      lead_id: record.lead_id,
    }),
  };
  useEffect(() => {
    setTeamAssignigIds(selectedLeads);
  }, [selectedLeads]);

  return (
    <div>
      <div className="sales-data-report__sales-links">
        <EditUserModal
          showEditModal={showEditModal}
          toggleEditModal={toggleEditModal}
          editUser={currentEditUser}
          currentPage={currentPage}
          queryString={queryString}
          getSalesListData={getSalesListData}
        />
        <DeleteModal
          showDeleteModal={showDeleteModal}
          toggleDeleteModal={toggleDeleteModal}
          editUser={currentEditUser}
          currentPage={currentPage}
          queryString={queryString}
          getSalesListData={getSalesListData}
        />
        {localUserData?.role === "1" && (
          <div style={{ marginBottom: 10 }}>
            <Row align="middle" gutter={10} wrap={false}>
              <Col>
                <Button onClick={genarateCronData}>Generate Cron Job</Button>
              </Col>

              <Col>
                <Button onClick={generateVoicemails}>
                  Generate Voicemail Job
                </Button>
              </Col>

              <Col>
                <Button onClick={generateSubmissionLeads}>
                  Submission Leads
                </Button>
              </Col>

              <Col>
                <Button onClick={generateWalkoutLeads}>Walkout Leads</Button>
              </Col>

              <Col>
                <Input
                  placeholder="Enter user email"
                  value={otpEmail}
                  onChange={(e) => setOtpEmail(e.target.value)}
                  style={{ width: 220 }}
                />
              </Col>

              <Col>
                <Button
                  type="primary"
                  loading={loadingOtp}
                  onClick={handleGetOtp}
                >
                  Get OTP
                </Button>
              </Col>

              {fetchedOtp && (
                <Col>
                  <div
                    style={{
                      background: "#f5f5f5",
                      padding: "6px 12px",
                      borderRadius: 6,
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    OTP: {fetchedOtp}
                  </div>
                </Col>
              )}
            </Row>
            <hr />
          </div>
        )}
        {localUserData?.userId === 1 && (
          <div className="sales-data-report__header">
            <div>
              <Button
                onClick={() => {
                  setCurrentPage(1);
                  setQueryString("status=0");
                  window.location.hash = "#pending";
                }}
              >
                Pending - {formateNum(filterCount.pending, ",")}
              </Button>
              <Button
                onClick={() => {
                  setCurrentPage(1);
                  setQueryString("status=1");
                  window.location.hash = "#Interested";
                }}
              >
                Interested - {formateNum(filterCount.interested, ",")}
              </Button>
              <Button
                onClick={() => {
                  setCurrentPage(1);
                  setQueryString("status=3");
                  window.location.hash = "#followup";
                }}
              >
                followup - {formateNum(filterCount.followup, ",")}
              </Button>
              <Button
                onClick={() => {
                  setCurrentPage(1);
                  setQueryString("status=2");
                  window.location.hash = "#notInterested";
                }}
              >
                Not Interested - {formateNum(filterCount.notInterested, ",")}
              </Button>
              <Button
                onClick={() => {
                  setCurrentPage(1);
                  setQueryString("status=4");
                  window.location.hash = "#voicemail";
                }}
              >
                Voicemail - {formateNum(filterCount.voicemail, ",")}
              </Button>
              <Button
                onClick={() => {
                  setCurrentPage(1);
                  setQueryString("status=5");
                  window.location.hash = "#invalidNumber";
                }}
              >
                Invalid Number - {formateNum(filterCount.invalidNumber, ",")}
              </Button>
              <Button
                onClick={() => {
                  setCurrentPage(1);
                  setQueryString("status=6");
                  window.location.hash = "#notInService";
                }}
              >
                Not In Service - {formateNum(filterCount.notInService, ",")}
              </Button>
              <Button
                onClick={() => {
                  setCurrentPage(1);
                  setQueryString("status=7");
                  window.location.hash = "#dnd";
                }}
              >
                DND- {formateNum(filterCount.dnd, ",")}
              </Button>
              <Button
                onClick={() => {
                  setCurrentPage(1);
                  setQueryString("status=8");
                  window.location.hash = "#citizens";
                }}
              >
                Citizens - {formateNum(filterCount.citizens, ",")}
              </Button>
              <Button
                disabled={location.hash === ""}
                onClick={() => {
                  setCurrentPage(1);
                  setQueryString(null);
                  navigate("/sales");
                }}
              >
                Reset
              </Button>
            </div>
            {/* <div>
                      <p>Total Records : {formateNum(totalCount, ",")}</p>
                    </div> */}
          </div>
        )}
      </div>
      <ContentHeader
        showBtn={localUserData?.role === "1"}
        redirectPath="/sales/data-upload"
        buttonText="Upload Data"
        title="Sales"
        showIcon
        Icon={FiPlusCircle}
      />
      <SearchFilter
        fields={generateSearchFields}
        onSubmit={(queryStrings: any) => {
          setCurrentPage(1);
          setQueryString(queryStrings);
        }}
        clearSearch={() => {
          setCurrentPage(1);
          setQueryString(null);
        }}
        showButtons={true}
        colVal={4}
      />
      {localUserData?.role === "1" && localUserData?.userId === 1 && (
        <div>
          <DownloadCsv
            headers={columns.slice(0, columns.length - 1).map((col: any) => ({
              title: col.title,
              key: col.key,
              formate: col?.render ? exportFormates[col.key] : false,
            }))}
            filename={"Sales"}
            disabled={queryString ? false : true}
            URL={
              queryString
                ? `/sales/contacts?download=1&${queryString}`
                : "/sales/contacts?download=1"
            }
          />
        </div>
      )}
      {/* {JSON.stringify(filteredData)} */}

      <>
        {localUserData?.role === "2" && localUserData?.departmentId === 1 && (
          <Row style={{ marginTop: "5px", marginBottom: "10px" }}>
            <Col span={3}>Assign Multiple:</Col>

            <Col span={6}>
              <Select
                style={{
                  width: "100%",
                }}
                placeholder="Select Team Member"
                onChange={(e: any) => doMultipleAssign(e)}
                options={teamList}
                showSearch
                filterOption={filterOption}
                className="ant-col ant-form-item-control css-dev-only-do-not-override-3rel02"
              />
            </Col>
          </Row>
        )}
      </>

      <Table
        rowClassName="editable-row"
        bordered
        columns={columns}
        dataSource={salesList}
        pagination={false}
        loading={isLoading}
        rowSelection={rowSelection}
        rowKey="id"
      />
      <Pagination
        onChange={(pagination: any) => {
          setCurrentPage(pagination);
        }}
        style={{ marginTop: "15px" }}
        current={currentPage}
        defaultPageSize={25}
        showSizeChanger={false}
        hideOnSinglePage
        total={totalCount}
      />
    </div>
  );
};

export default Sales;
